if (window.matchMedia('(hover: hover)').matches) {
  document.querySelectorAll('.product-form__input--swatch').forEach((fieldset) => {
    const label = fieldset.querySelector('[data-selected-value]');
    if (!label) return;

    const revertToChecked = () => {
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      label.textContent = checked ? checked.value : '';
    };

    fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.addEventListener('mouseenter', () => {
        label.textContent = input.value;
      });
    });

    fieldset.addEventListener('mouseleave', revertToChecked);
  });
}
